import * as Yup from 'yup';

import { TAX_PAYER_TYPE } from '@/store/profile';
import {
	requiresTaxId,
	requiresVat,
	validateVat,
	validateVatPrefix
} from '@/utils/billing';

export default ({ t = () => '', sync }) =>
	Yup.object({
		type: Yup.string().oneOf(Object.values(TAX_PAYER_TYPE)).required(),
		companyName: Yup.string().when('type', {
			is: TAX_PAYER_TYPE.COMPANY,
			then: schema => schema.required(),
			otherwise: schema => schema.nullable()
		}),
		vatNumber: Yup.string().when(
			['country', 'type'],
			([country, type], schema) => {
				if (
					!requiresVat({
						country,
						type
					})
				) {
					return schema.nullable();
				}

				if (sync) {
					return schema
						.test({
							name: 'vatNumberPrefix',
							test: validateVatPrefix(t)
						})
						.required();
				}

				return schema
					.test({
						name: 'vatNumberPrefix',
						test: validateVatPrefix(t)
					})
					.test({
						name: 'vatNumber',
						test: validateVat(t)
					})
					.required();
			}
		),
		taxId: Yup.string().when('country', {
			is: countryValue => requiresTaxId(countryValue),
			then: schema => schema.required(),
			otherwise: schema => schema.nullable()
		}),
		firstName: Yup.string().required(),
		lastName: Yup.string().required(),
		email: Yup.string().email(),
		zipCode: Yup.string().required(),
		country: Yup.string().required(),
		city: Yup.string().required(),
		address: Yup.string().required()
	});
